import React, { useContext } from 'react';
import { StepsBannerArrows } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import './verification.scss';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import VerifyCode from '../../components/verifyCode/verifyCode';
import { SLICES } from '../../constants/slices';
import { FORM_KEYS } from '../../constants/formKeys';
import useVerify from './useVerify';
import Alert from '../../components/shared/Alert/Alert';
import { ALERT_ERROR_MESSAGE } from '../../constants/errorMessage';
import { FAQContent } from '../../components/liveVet/faqContent';
import { FAQ_CODENAME } from '../../constants/cmsCodeName';
import Loading from '../../components/shared/Loading/Loading';
import { BrandContext } from '../../contextProviders/brandContext';

const title = 'SMS Verification';

const VerificationBySms = () => {
  const { watch } = useFormContext();
  const { tokenClaims } = useSelector((state) => state?.[SLICES.AUTHENTICATION]);

  const {
    activeBrandContext: {
      brand: { supportPhoneNumber }
    }
  } = useContext(BrandContext);

  const {
    getVerifyCode,
    isCodeSent,
    confirmUserEnrollment,
    errorMessage,
    updateUserLoading,
    verifyUserLoading,
    confirmEnrollmentLoading,
    timeLeft
  } = useVerify({
    verifyType: 'verify-sms',
    verifyTypeInput: tokenClaims?.phoneNumber,
    verifyCode: watch(FORM_KEYS.VERIFY_PHONE_CODE),
    isEnabled: tokenClaims?.phoneNumber
  });

  const steps = [
    { isCompleted: true, isActive: false, label: 'VERIFY EMAIL' },
    { isCompleted: false, isActive: true, label: 'VERIFY PHONE' }
  ];

  if (updateUserLoading || verifyUserLoading || confirmEnrollmentLoading) {
    return <Loading />;
  }

  return (
    <>
      <div className="verifiyContainer">
        <StepsBannerArrows steps={steps} />
        {!tokenClaims?.phoneNumber ? (
          <>
            <h1 className="pageTitle">{title}</h1>
            <Alert
              type="error"
              message={ALERT_ERROR_MESSAGE.SIGN_UP_NO_MOBILE_NUMBER(supportPhoneNumber)}
            />
          </>
        ) : (
          <VerifyCode
            type="sms"
            typeValue={tokenClaims?.phoneNumber}
            title={title}
            handleSendCode={getVerifyCode}
            handleVerifyCode={confirmUserEnrollment}
            isCodeSent={isCodeSent}
            errorMessage={errorMessage}
            timeLeft={timeLeft}
          />
        )}
      </div>
      <FAQContent faqCategory={FAQ_CODENAME.VERIFY_SMS} />
    </>
  );
};

export default VerificationBySms;
